(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["direct-checkout-button"] && !Shopify.designMode) return;
  try {
    class DirectCheckoutButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-direct-checkout-action]');
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
    }

    handleClick = async () => {
      const productForm = this.closest('product-form-component');
      const form = productForm?.querySelector('form');

      if (!form || !form.reportValidity() || !this.button) return;

      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: new FormData(form),
        });
        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || '');
        }

        window.location.assign(`${root}checkout`);
      } catch (error) {
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');

        const message = error instanceof Error ? error.message : '';
        const liveRegion = productForm?.querySelector('[ref="liveRegion"]');

        if (message && liveRegion) {
          liveRegion.textContent = message;
        }
      }
    };
  }

  if (!customElements.get('direct-checkout-button')) {
    customElements.define('direct-checkout-button', DirectCheckoutButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-social-proof"] && !Shopify.designMode) return;
  try {
    (() => {
    const proof = document.querySelector('.vx-product-proof');
    if (!proof) return;

    const updateSummary = () => {
      const summary = document.querySelector('.AirReviews-Widget--AppBlockSummary');
      if (!summary) return false;

      const ratingNode = summary.querySelector('[aria-label*="out of 5 stars"]');
      const countNode = summary.querySelector('.AirReviews-StarRate--Count');
      const ratingMatch = ratingNode?.getAttribute('aria-label')?.match(/([\d.,]+)\s+out of 5 stars/i);
      const countMatch = countNode?.textContent?.match(/\d[\d,]*/);

      if (!ratingMatch || !countMatch) return false;

      summary.classList.add('vx-product-summary');
      countNode.hidden = true;

      let meta = summary.querySelector('.vx-review-meta');
      if (!meta) {
        meta = document.createElement('span');
        meta.className = 'vx-review-meta';
        summary.append(meta);
      }

      const reviewText = `${ratingMatch[1]}/5 · ${countMatch[0]} Customer Reviews`;
      if (meta.textContent !== reviewText) meta.textContent = reviewText;

      return true;
    };

    const start = () => {
      updateSummary();

      const observer = new MutationObserver(updateSummary);
      observer.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(() => observer.disconnect(), 15000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
